export default __webpack_public_path__ + "static/media/54.bf35b960.png";